export const formatDate = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(d);
};

export const formatDateShort = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
  }).format(d);
};

export type CurrencyTone = "neg" | "pos" | "zero";

export const formatCurrency = (
  n: number,
): { text: string; tone: CurrencyTone } => {
  const tone: CurrencyTone = n < 0 ? "neg" : n > 0 ? "pos" : "zero";
  const text = `${n < 0 ? "−" : ""}$${Math.abs(n).toFixed(2)}`;
  return { text, tone };
};

export const cls = (
  ...parts: (string | false | undefined | null)[]
): string => parts.filter(Boolean).join(" ");
